import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SITE } from "@/data/site";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-brand-bg py-24 lg:py-32 border-t border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-brand-accent">Otázky</div>
            <h2 className="mt-4 font-display font-black text-4xl lg:text-6xl leading-[1.05] tracking-tight">
              Vše, co{" "}
              <span className="italic font-light">potřebujete vědět.</span>
            </h2>
            <p className="mt-6 text-brand-muted leading-relaxed max-w-md">
              Nenajdete tu odpověď? Napište nám na WhatsApp{" "}
              <a
                href={`https://wa.me/${SITE.whatsappRaw}`}
                target="_blank"
                rel="noreferrer"
                className="text-brand-accent hover:underline"
              >
                {SITE.whatsappNumber}
              </a>
              .
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {SITE.faq.map((item, idx) => (
                <AccordionItem
                  key={idx}
                  value={`item-${idx}`}
                  data-testid={`faq-item-${idx}`}
                  className="border-b border-brand-border"
                >
                  <AccordionTrigger className="text-left text-white hover:text-brand-accent hover:no-underline py-6 font-display font-bold text-lg lg:text-xl">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-muted text-base leading-relaxed pb-6">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
